var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Legend"},[_c('LegendPlanmode',{staticClass:"mt-3",attrs:{"label":"Laadpalen"}}),_c('LegendPrognose',{staticClass:"mt-5"}),_c('LegendSegment',{staticClass:"mt-5",attrs:{"label":"Context informatie"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }